import {
    /** role: */
    APPLICANT,
    CCO,
    CLUSTER_ADMIN,
    IRB,
    SECRETARY,
    REVIEWER,
    // HO_ADMIN,
    
    /** status: */
    DRAFT,
    SUBMITTED,
    RE_SUBMITTED,
    RETURNED,
    CONFIRMED,
    FOR_REVIEW,
    APPROVED,
    ACKNOWLEDGED,
    DISAPPROVED,
    WITHDRAWN,
    TERMINATED,
    COMPLETED,
    EXPIRED,
    RETURN_FROM_IRB,
    REJECT_REQUEST_FOR_RETURN,
    REVIEWED,
    REQUEST_FOR_RETURN,
    VERIFIED,
    DISTRIBUTED,
} from './lookup';

export const applicationPath = '/applications';
export const postApprovalDocumentPath = '/post-approval-document';

export const statusAndFolder = {
    [DRAFT]: {
        [APPLICANT]: {
            url: '/draft'
        },
    },
    [SUBMITTED]: {
        [APPLICANT]: {
            url: '/sent',
            label: 'Sent',
        },
        [CCO]: {
            url: '/received'
        },
        [SECRETARY]: {
            url: '/received'
        },
    },
    [RE_SUBMITTED]: {
        [APPLICANT]: {
            url: '/sent'
        },
        [CCO]: {
            url: '/received'
        },
        [CLUSTER_ADMIN]: {
            url: '/received'
        },
        [SECRETARY]: {
            url: '/received'
        },
    },
    [RETURNED]: {
        [APPLICANT]: {
            url: '/returned'
        },
        [CCO]: {
            url: '/returned'
        },
        [CLUSTER_ADMIN]: {
            url: '/returned'
        },
        [SECRETARY]: {
            url: '/returned'
        },
    },
    [CONFIRMED]: {
        [APPLICANT]: {
            url: '/sent'
        },
        [CCO]: {
            url: '/confirmed'
        },
        [CLUSTER_ADMIN]: {
            url: '/verified'
        },
        [IRB]: {
            url: '/confirmed'
        },
        [SECRETARY]: {
            url: '/confirmed'
        },
    },
    [FOR_REVIEW]: {
        [APPLICANT]: {
            url: '/sent'
        },
        [CCO]: {
            url: '/for-review'
        },
        [CLUSTER_ADMIN]: {
            url: '/verified'
        },
        [IRB]: {
            url: '/for-review'
        },
        [SECRETARY]: {
            url: '/for-review'
        },
        [REVIEWER]: {
            url: '/for-review'
        },
    },
    [APPROVED]: {
        [APPLICANT]: {
            url: '/approved'
        },
        [CCO]: {
            url: '/approved'
        },
        [CLUSTER_ADMIN]: {
            url: '/verified'
        },
        [IRB]: {
            url: '/approved'
        },
        [SECRETARY]: {
            url: '/approved'
        },
    },
    [ACKNOWLEDGED]: {
        [APPLICANT]: {
            url: '/acknowledged'
        },
        [CCO]: {
            url: '/acknowledged'
        },
        [CLUSTER_ADMIN]: {
            url: '/verified'
        },
        [IRB]: {
            url: '/acknowledged'
        },
        [SECRETARY]: {
            url: '/acknowledged'
        },
    },
    [DISAPPROVED]: {
        [APPLICANT]: {
            url: '/archived'
        },
        [CCO]: {
            url: '/archived'
        },
        [CLUSTER_ADMIN]: {
            url: '/archived'
        },
        [IRB]: {
            url: '/archived'
        },
        [SECRETARY]: {
            url: '/archived'
        },
    },
    [WITHDRAWN]: {
        [APPLICANT]: {
            url: '/archived'
        },
        [CCO]: {
            url: '/archived'
        },
        [CLUSTER_ADMIN]: {
            url: '/archived'
        },
        [IRB]: {
            url: '/archived'
        },
        [SECRETARY]: {
            url: '/archived'
        },
    },
    [TERMINATED]: {
        [APPLICANT]: {
            url: '/archived'
        },
        [CCO]: {
            url: '/archived'
        },
        [CLUSTER_ADMIN]: {
            url: '/archived'
        },
        [IRB]: {
            url: '/archived'
        },
        [SECRETARY]: {
            url: '/archived'
        },
    },
    [COMPLETED]: {
        [APPLICANT]: {
            url: '/completed'
        },
        [CCO]: {
            url: '/completed'
        },
        [CLUSTER_ADMIN]: {
            url: '/archived'
        },
        [IRB]: {
            url: '/completed'
        },
        [SECRETARY]: {
            url: '/completed'
        },
    },
    [EXPIRED]: {
        [APPLICANT]: {
            url: '/expired'
        },
        [CCO]: {
            url: '/expired'
        },
        [CLUSTER_ADMIN]: {
            url: '/archived'
        },
        [IRB]: {
            url: '/expired'
        },
        [SECRETARY]: {
            url: '/expired'
        },
    },
    [RETURN_FROM_IRB]: {
        [APPLICANT]: {
            url: '/sent'
        },
        [CCO]: {
            url: '/returnedFromIRB'
        },
        [CLUSTER_ADMIN]: {
            url: '/verified'
        },
        [IRB]: {
            url: '/returnedFromIRB'
        },
    },
    [REJECT_REQUEST_FOR_RETURN]: {
        [APPLICANT]: {
            url: '/all'
        },
        [CCO]: {
            url: '/all'
        },
        [CLUSTER_ADMIN]: {
            url: '/all'
        },
        [IRB]: {
            url: '/all'
        },
        [SECRETARY]: {
            url: '/all'
        },
    },
    [REVIEWED]: {
        [APPLICANT]: {
            url: '/sent'
        },
        [CCO]: {
            url: '/reviewed'
        },
        [CLUSTER_ADMIN]: {
            url: '/verified'
        },
        [IRB]: {
            url: '/reviewed'
        },
        [SECRETARY]: {
            url: '/reviewed'
        },
    },
    [REQUEST_FOR_RETURN]: {
        [APPLICANT]: {
            url: '/sent'
        },
        [CCO]: {
            url: '/received'
        },
        [CLUSTER_ADMIN]: {
            url: '/received'
        },
        [SECRETARY]: {
            url: '/received'
        },
    },
    [VERIFIED]: {
        [APPLICANT]: {
            url: '/sent'
        },
        [CCO]: {
            url: '/verified'
        },
        [CLUSTER_ADMIN]: {
            url: '/verified'
        },
    },
    [DISTRIBUTED]: {
        [APPLICANT]: {
            url: '/sent'
        },
        [CCO]: {
            url: '/distributed'
        },
        [CLUSTER_ADMIN]: {
            url: '/received'
        },
    },
};

export const menuFolder = {
    application: statusAndFolder,
    postApprovalDocument: statusAndFolder,
};